module.exports = __webpack_public_path__ + "img/1.273f137c.png";